<template>
  <div class="p-2 bg-white border rounded"> 
    <div class="alert alert-warning pt-4 mb-0"> 
      <p><strong class="gap-10px d-flex"><i class="lh-inherit far fa-info-circle"></i> {{ 'Some files did have issues' }}</strong></p>

      <p v-for="warning in currentJob.apiJob?.warnings">{{ getTranslatedError(warning.code) |trans}}</p>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import {EventBus} from "../../events/event.bus";
import {EVENT_SHARE} from "../../events/app.events";

export default {
  name: "Warning",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      errors : {
        6000: 'Something went wrong while converting your file.',
        6001: 'Your file is DRM protected and therefore we are not allowed to convert it.',
        6002: 'The file is password protected. Please provide the password.',
        6004: 'Unfortunately, we can not convert your source file format to the target file format.',
        6005: 'Your file is missing important metadata and therefore we can not convert it.',
        6006: 'The files inside an archive must be of the same type.',
        6011: 'The file is password protected. Please provide the password.',
        6012: 'There was a temporary error with your conversion. Please try again later. We had a problem on our side. Normally it is auto fixed in a few seconds.',
        6018: 'The file seems to be broken and we are unable to fix it.',
        6019: 'Your file uses an unsupported encryption format.',
        6020: 'Your conversion took too long and was canceled.',
        6021: 'Width or height exceed the limit for icons. Please make sure the largest side is set to max 256px.',
        6022: 'There has been an error converting your file.',
        6023: 'The job has an input file which is too old.',
        6024: 'We could not compress this file any further.',
        6026: 'Width or height exceed the limit for AI upscaling. Please make sure the largest side is set to max 2000px.',
        6029: 'The input file is not a valid PDF.',
        6030: 'All slides in the presentation are marked as hidden.',
        6031: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6032: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6033: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6035: 'We could not automatically create a PDF/A from your document. Some of the elements within your PDF may be incompatible with your selected PDF/A standard. Please try converting your file to another PDF/A standard.',
        6036: 'We are not able to extract any embedded assets from the file.',
        6037: 'The values for width or height are too large. Please try again with smaller values.',
        6038: 'The resulting duration of the converted video is too long (>4 hrs).',
        6039: 'Please, retry the conversion without the OCR option.',
        6046: 'The input file is not compliant with the selected PDF/A validation profile.',
        6047: 'There has been an error validating your file.',
        6048: 'Please, retry the conversion without the OCR option.',
        6049: 'Please, retry the conversion with the OCR option.',
        6051: 'There has been an error validating your file.',
        6052: 'We could not extract any text from your file.',
        6053: 'We could not extract any audio from your file.',
        6054: 'AI upscale cannot be used to downscale an image.',
        6056: 'We are not able to extract any embedded assets from this file format yet.',
        6057: 'Your file cannot be converted to the selected PDF/A standard while in non-strict mode.',
        20000: 'Unfortunately, we detected an issue during the conversion. We converted your file as best as possible, but it might be only partially converted. Please check it manually.',
        20003: 'Unfortunately, we can not convert your source file format to the target file format.',
        20004: 'The rendered output may be incorrect.',
        20005: 'Your file uses an unsupported encryption format.',
        20006: 'The DPI value may be incorrect.',
        20007: 'We could not compress this file any further.',
        20008: 'The version of the converted file has been downgraded.',
        20009: 'It was not possible to preserve transfer functions in PDF 2.0.',
        20011: 'The value for the audio frequency is too low. The conversion used the lowest possible value allowed. You can also try again with a higher value or with a different codec.',
        20012: 'The value for the audio frequency is too high. The conversion used the highest possible value allowed. You can also try again with a smaller value or with a different codec.',
        20013: 'The value for the audio frequency is not allowed. The conversion used the highest possible value allowed. You can also try again with another value or with a different codec.',
        20014: 'The sizes of the reference image and the compared image do not match. The result can be inaccurate.',
        20015: 'The sizes of the reference video and the compared video do not match. The result can be inaccurate.',
        20016: 'The codec of the input file does not fit the video codec. A different one was chosen.',
        20018: 'The width or height exceed the limit for AI upscaling for your file. The maximum possible size is provided.',
        20022: 'During compression we detected a larger quality degradation. Please check the result.',
        20024:'The conversion may result in excessively loud audio, which can be harmful to your hearing and damage speakers or headphones.',
        ocr_needed: 'Your file could not be converted, please retry the conversion with the OCR option enabled.',
        6058: 'AI upscale percentage out of range. It should be between 101 and 400.',
        premium_limit_reached: 'You have reached the limitations of your account.',
      }
    };
  },
  mounted: function () {

  },
  created: function () {
  },
  methods: {
    getTranslatedError(code) {
      if (typeof this.errors[code] !== 'undefined') {
        return this.translate(this.errors[code]);
      }

      return this.translate(this.errors[6000]);
    }
  },
  computed: {

  }
};
</script>
<style lang="scss" scoped>

</style>
